import { makeStyles } from "@fluentui/react-components";

export const useTabContainerStyles = makeStyles({
  tabContainer: {
    columnGap: "1px",
    backgroundColor: "transparent",
  },
});
